import React, { Component, useState } from "react";
import Alert from "react-s-alert";
import axios from "axios";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import SimpleReactLightbox from "simple-react-lightbox";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SingleImageReusableComponent from "../../../../reusableComponents/imageUploadReusableComponent/SingleImageReusableComponent";
import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import { AddButtonIconComponent } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import SVG from "react-inlinesvg";
import AlertDialogProgress from "../../../../reusableComponents/allPopupReusable/DialogProgression";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";

import isEmpty from "../../../../../store/validation/is-Empty";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { superadmin_create_and_update_restaurant } from "../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import {
  serverApi,
  imageUploadSize,
  videoUploadSize,
  SQUARE_IMG_MIN_DIME,
  SQUARE_IMG_MAX_DIME,
  RECTANGLE_IMG_MAX_WIDTH,
  RECTANGLE_IMG_MAX_HEIGHT,
  VIDEO_MIN_WIDTH,
} from "../../../../../config/Keys";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

export class SuperAdminAddRestaurantDetails extends Component {
  fileObj = [];
  fileArray = [];

  constructor(props) {
    super(props);
    this.state = {
      vendor_id: "",
      actionButton: false,
      hasSetMapProps: false,
      loader: false,
      restaurant_description: "",
      logo_url: "",
      logo_main: null,
      restaurant_pictures: [],
      restaurant_pictures_new: [],
      restaurant_video: [],
      video_url: "",
      things_nearby: "",
      keywords: [],
      keywordsText: "",
      errors: {},
      errorValue: false,
      progress: 0,
    };
  }

  async componentDidMount() {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let adminVendorId = this.props?.editDataAction
      ? this.props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
    const formData = {
      vendor_id: adminVendorId,
    };
    if (adminVendorId !== null || adminVendorId !== undefined) {
      this.props.superadmin_create_and_update_restaurant(formData);
      this.setState({
        vendor_id: formData.vendor_id,
      });
    }
    if (onboarding?._id) {
      this.setState({
        restaurant_description: !isEmpty(onboarding?.restaurant_description)
          ? onboarding?.restaurant_description
          : "",
        logo_url: !isEmpty(onboarding?.logo_url) ? onboarding?.logo_url : "",
        restaurant_pictures: !isEmpty(onboarding?.restaurant_pictures)
          ? onboarding?.restaurant_pictures
          : [],
        video_url: !isEmpty(onboarding?.restaurant_video)
          ? onboarding?.restaurant_video
          : "",
        things_nearby: !isEmpty(onboarding?.things_nearby)
          ? onboarding?.things_nearby
          : "",
        keywords: !isEmpty(onboarding?.keyword_search)
          ? onboarding?.keyword_search
          : [],
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let onboarding = nextProps?.editDataAction
      ? nextProps?.editData
      : nextProps?.onboardingData;
    if (
      onboarding?._id &&
      nextProps.auth.user.VendorUser &&
      !isEmpty(onboarding?.location)
    ) {
      if (
        // !isEmpty(onboarding?.location?.latitude) &&
        // !isEmpty(onboarding?.location?.longitude) &&
        !isEmpty(nextProps?.auth?.user?.VendorUser?.country_code) &&
        !nextState.hasSetMapProps
        //   ||
        // nextState?.location?.latitude !== onboarding?.location?.latitude
      ) {
        return {
          localizationText: !isEmpty(
            nextProps?.auth?.user?.VendorUser?.country_code +
              nextProps?.auth?.user?.VendorUser?.country
          )
            ? nextProps?.auth?.user?.VendorUser?.country_code +
              nextProps?.auth?.user?.VendorUser?.country
            : "+91IN",

          // location: !isEmpty(onboarding?.location)
          //   ? onboarding?.location
          //   : { latitude: "", longitude: "" },

          restaurant_description: !isEmpty(onboarding?.restaurant_description)
            ? onboarding?.restaurant_description
            : "",
          logo_url: !isEmpty(onboarding?.logo_url) ? onboarding?.logo_url : "",
          restaurant_pictures: !isEmpty(onboarding?.restaurant_pictures)
            ? onboarding?.restaurant_pictures
            : [],
          // restaurant_pictures: [],
          // this.state.restaurant_pictures,
          video_url: !isEmpty(onboarding?.restaurant_video)
            ? onboarding?.restaurant_video
            : "",
          things_nearby: onboarding?.things_nearby,
          keywords: !isEmpty(onboarding?.keyword_search)
            ? onboarding?.keyword_search
            : [],
          hasSetMapProps: true,
        };
      }
    }
    if (nextProps?.auth?.loader !== nextState.loader) {
      return {
        loader: nextProps?.auth?.loader,
      };
    }
    if (nextProps?.errors !== nextState?.errors) {
      return {
        errors: nextState?.errors,
      };
    }
    return null;
  }

  onChange = (e) => {
    this.props.clear_all_errors();
    if (
      e.target.name === "restaurant_description" ||
      e.target.name === "things_nearby"
    ) {
      let caps = e.target.value;
      caps = caps.charAt(0).toUpperCase() + caps.slice(1);
      let dataSet = caps;
      this.setState({
        // [e.target.name]: e.target.value
        [e.target.name]: dataSet,
        actionButton: true,
        errorValue: false,
      });
    } else {
      let data = e.target.value.split(" ");
      let newarray1 = [];
      for (let x = 0; x < data.length; x++) {
        newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
      }
      let newData = newarray1.join(" ");
      this.setState({
        [e.target.name]: newData,
        actionButton: true,
        errorValue: false,
      });
    }
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
      this.setState({ errorValue: true });
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /**************************************
   * @DESC - ON IMAGE UPLOAD HANDLER
   * @DESC - USER DEFINED METHODS
   **************************************/

  onCompleteCrop = (url) => {
    this.setState({
      logo_url: url,
      logo_main: null,
      singleImageLoader: false,
      actionButton: true,
    });
  };

  onCancelCrop = () => {
    this.setState({ logo_main: null });
  };

  onImageLogoUploadHandler = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    try {
      const vendor_id = this.state.vendor_id;
      const restaurant_name = onboarding?.restaurant_name.split(" ").join("");
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      data.append("files", e.target.files[0]);
      if (e.target.files[0].size > imageUploadSize) {
        alert("File is too Big");
      } else {
        this.setState({
          logo_main: e.target.files[0],
          combined: combined,
        });
      }
      e.target.value = "";
    } catch (err) {
      console.log(err);
    }
  };

  removeFile = () => {
    console.log(this.state.logo_url);
    let restaurantLogo = this.state.logo_url;
    restaurantLogo = "";
    this.setState({
      logo_url: restaurantLogo,
      actionButton: true,
    });
  };

  /*******************************
   * Add Keywords Action
   ******************************/
  addKeywordsAction = (e) => {
    e.preventDefault();
    let keywordsText = this.state.keywordsText;
    let keywords = this.state.keywords;
    if (keywordsText === "") {
      const { errors } = this.state;
      errors.keywordsText = "Keywords is Required";
      this.setState({
        errors: errors,
      });
    } else if (keywords.some((diner) => diner === keywordsText)) {
      alert("Keywords Already Exits");
    } else {
      keywords.push(keywordsText);
      this.setState({
        keywords: keywords,
        keywordsText: "",
      });
    }
  };

  /*************************************
   * @DESC Keywords Change Handlers
   ************************************/
  onKeywordsChangeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      actionButton: true,
      errors: {},
    });
  };

  /*************************************
   * @DESC Remove Keywords Change Handlers
   ************************************/
  removeKeywordsAction = (indexId) => (e) => {
    let keywords = this.state.keywords;
    let keywordsObj = keywords.find((images, index) => index === indexId);
    if (keywordsObj === 0 || keywordsObj) {
      keywords.splice(keywords.indexOf(keywordsObj), 1);
      this.setState({ keywords: keywords });
    }
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/

  onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = this.state.restaurant_pictures;
    oldData.push(e);

    this.setState({
      restaurant_pictures: oldData,
      // multipleImageLoader: false,
      actionButton: true,
    });
    this.cancelFiles(file);
  };
  cancelFiles = (file) => {
    let restaurant_pictures_temp = this.state.restaurant_pictures_new;
    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    this.setState({ restaurant_pictures_new: newToUpload });
  };
  uploadMultipleFiles = (e) => {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    // this.setState({ multipleImageLoader: true });
    const vendor_id = this.state.vendor_id;
    const restaurant_name = onboarding?.restaurant_name.split(" ").join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    var newUploaded = [];
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > imageUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else if (e.target.files.length > 10) {
        alert("You can upload only 10 files");
        return (flag = false);
      } else {
        let allPicures = this.state.restaurant_pictures;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            // flag = true;
            return (flag = true);
          } else {
            return (flag = false);
          }
        });
        if (!flag) {
          newUploaded.push(e.target.files[i]);
          data.append("files", e.target.files[i]);
        }
      }
    }
    // console.log(e.target.files);
    if (!flag) {
      this.setState({
        restaurant_pictures_new: newUploaded,
        combined: combined,
      });
    } else {
      Alert.error(`<h4>Can not upload the same image</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    e.target.value = "";
  };

  multipleResetFile = (indexId) => {
    let allPicures = this.state.restaurant_pictures;
    let allPicuresObj = allPicures.find((images, index) => index === indexId);
    if (allPicuresObj === 0 || allPicuresObj) {
      allPicures.splice(allPicures.indexOf(allPicuresObj), 1);
      this.setState({ allPicures: allPicures, actionButton: true });
    }
  };

  /*************************************
   * @DESC Multiple Video Upload
   ************************************/
  uploadMultipleVideoFiles = (e) => {
    e.preventDefault();
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    // this.setState({ multipleImageLoader: true });
    const vendor_id = this.state.vendor_id;
    const restaurant_name = onboarding?.restaurant_name.split(" ").join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > videoUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else {
        if (
          this.state.restaurant_video &&
          this.state.restaurant_video.length > 0
        ) {
          if (this.state.restaurant_video[0].name === e.target.files[i].name) {
            return (flag = true);
          }
        }
        if (!flag) {
          data.append("file", e.target.files[i]);
        }
      }
    }
    // ?uploadSide=${combined}
    var newData = e.target.files;
    if (!flag) {
      const setProgress = (percent) => {
        this.setState({ progress: percent });
      };
      axios
        .post(`${serverApi}/upload-assets-video`, data, {
          onUploadProgress: (progressEvent) => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
        .then((res) => {
          this.setState({ video_url: "" });
          this.setState({
            restaurant_video: newData,
            video_url: res.data,
            actionButton: true,
          });
          Alert.success(`<h4>Restaurant Video Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // this.setState({ multipleImageLoader: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      // this.setState({ multipleImageLoader: false });
      Alert.error(`<h4>Can not upload the same video</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    e.target.value = "";
  };

  multipleVideoResetFile = (e) => {
    let video_url = this.state.video_url;
    let restaurant_video = this.state.restaurant_video;
    video_url = "";
    restaurant_video = [];
    this.setState({
      restaurant_video: restaurant_video,
      video_url: video_url,
      actionButton: true,
    });
    // this.setState({ restaurant_video: [], video_url: "", actionButton: true });
  };

  backbuttonClickhandler = (e) => {
    this.props.history.push({
      pathname: this.props?.editDataAction
        ? "/admin_edit_point_of_contact"
        : "/addvendorpointofcontact",
    });
  };

  withOutApiCall = (e) => {
    e.preventDefault();
    this.props.history.push({
      pathname: this.props?.editDataAction
        ? "/admin_edit_marchant_chain"
        : "/addvendorchain",
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    if (
      onboarding &&
      onboarding?.restaurant_description !== "" &&
      onboarding?.restaurant_description !== undefined &&
      onboarding?.restaurant_description !== null
    ) {
      if (onboarding?._id) {
        let formData = {
          vendor_id: this.state.vendor_id,
          id: onboarding?._id,
          restaurant_description: this.state.restaurant_description,
          logo_url: this.state.logo_url.toString(),
          restaurant_pictures: this.state.restaurant_pictures,
          restaurant_video: this.state.video_url,
          things_nearby: this.state.things_nearby,
          keyword_search: this.state.keywords,
        };
        this.props.superadmin_create_and_update_restaurant(formData);
        this.props.history.push({
          pathname: this.props?.editDataAction
            ? "/admin_edit_marchant_chain"
            : "/addvendorchain",
        });
      }
    } else {
      if (onboarding?._id) {
        let formData = {
          vendor_id: this.state.vendor_id,
          id: onboarding?._id,
          restaurant_description: this.state.restaurant_description,
          logo_url: this.state.logo_url.toString(),
          restaurant_pictures: this.state.restaurant_pictures,
          restaurant_video: this.state.video_url,
          things_nearby: this.state.things_nearby,
          keyword_search: this.state.keywords,
          page_completed_till: 4,
        };
        this.props.superadmin_create_and_update_restaurant(formData);
        this.props.history.push({
          pathname: this.props?.editDataAction
            ? "/admin_edit_marchant_chain"
            : "/addvendorchain",
        });
      }
    }
  };

  renderAllFields = () => {
    const {
      restaurant_description,
      logo_url,
      restaurant_pictures,
      restaurant_video,
      things_nearby,
      actionButton,
      keywords,
      keywordsText,
      errors,
      video_url,
      restaurant_pictures_new,
    } = this.state;
    return (
      <React.Fragment>
        <div>
          <div className="col-12 p-0">
            <NewInputText
              extraClass="text-area-labelText-padding-two mt-4"
              name="restaurant_description"
              onChange={this.onChange}
              onFocusOut={this.onFocusOut}
              rows="4"
              multiline={true}
              value={restaurant_description}
              errorText={
                errors.restaurant_description ===
                "*Fields can’t be blank. Please enter your restaurant_description"
                  ? "*Fields can’t be blank. Please enter your restaurant description"
                  : null
              }
              errorTrue={
                errors.restaurant_description ===
                "*Fields can’t be blank. Please enter your restaurant_description"
                  ? true
                  : false
              }
              labelText="Business Description and Details*"
              helpTextDisplay={true}
              helperTextBottom="Enter elaborate information about the Business to convey to your Audience group."
              controlClass={
                errors.restaurant_description ===
                "*Fields can’t be blank. Please enter your restaurant_description"
                  ? "outlined-error-helper-text"
                  : "outlined-helperText "
              }
            />
          </div>
          <div className="col-12 p-0 mb-4 onboarding-restaurant-details-margin">
            <div className="row align-items-center">
              <div className="col-12">
                <label className="f16-700 mb-2">Keywords for Search</label>
              </div>
              <div className="col-7">
                <NewInputText
                  extraClass="mb-0"
                  name="keywordsText"
                  onChange={this.onKeywordsChangeHandler}
                  value={keywordsText}
                  labelText="Keywords"
                />
                <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                  {errors.keywordsText}
                </div>
              </div>
              <div className="col-5">
                <AddButtonIconComponent
                  buttonText="Add More Keywords"
                  onClick={this.addKeywordsAction}
                  fontIcon="fa fa-plus"
                  colorCss="blue"
                />
              </div>
            </div>

            <div className="d-flex flex-wrap mt-2">
              {keywords &&
                keywords.map((data, index) => {
                  return (
                    <div className="mb-3 mr-3" key={index}>
                      <div className="keywords_button">
                        <p>{data}</p>
                        <span
                          className="ml-2"
                          onClick={this.removeKeywordsAction(index)}
                        >
                          <SVG
                            src={require("../../../../../assets/images/UserManagement/close.svg")}
                          />
                        </span>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <SimpleReactLightbox>
            <SingleImageReusableComponent
              title="Add Logo*"
              // smallTitle="( You can upload only 1 pic per offer 700 x 420 pixels )"
              // onDrop={this.onSingleImageDrop}
              onChange={this.onImageLogoUploadHandler}
              combined={this.state.combined && this.state.combined}
              onCompleteCrop={this.onCompleteCrop}
              onCancelCrop={this.onCancelCrop}
              file={
                (this.state.logo_main &&
                  this.state.logo_main !== null &&
                  this.state.logo_main) ||
                (this.state.logo_url && this.state.logo_url)
              }
              resetFile={this.removeFile}
              name="logo_url"
              error={errors.logo_url}
              // loader={this.state.singleImageLoader}
            />
            <div className="font_12_r c_gray mb-4 mt-3">
              <LearnMore
                preText={
                  <>
                    Only .jpg and .png files.{" "}
                    {/* {parseInt(imageUploadSize / 100000)} */}2 MB max file
                    size.
                  </>
                }
                mainContent={
                  <div className="f14-400">
                    <div className="f16-500">Logo images</div>
                    <br />· Logo Images must be SVG, PNG, or JPG file. We
                    strongly recommend SVG as it is scalable across a large
                    range of sizes without loss of quality. If a PNG or JPG
                    image is submitted, it must be between {
                      SQUARE_IMG_MIN_DIME
                    }{" "}
                    pixels and {SQUARE_IMG_MAX_DIME} pixels in size for Square
                    Logos and must be least {RECTANGLE_IMG_MAX_HEIGHT} pixels
                    high and cannot be more than {RECTANGLE_IMG_MAX_WIDTH}{" "}
                    pixels wide in case of Rectangular Logos. <br />
                    <br />· Images files can’t be larger than{" "}
                    {parseInt(imageUploadSize / 100000)}MB. <br />
                    <br />· Common quality issues that may lead to logo
                    rejection include: <br />
                    <br />- The logo contains a watermarked image - The logo
                    belongs to a different business establishment or doesn’t
                    match your current branding <br />
                    <br />- The logo contains text that is illegible when the
                    image is resized for smaller screens <br />
                    <br />- The logo contains too much white space (also known
                    as negative space). Negative space should not be added to an
                    image to make it fit within the dimensions. <br />
                    <br />- Any white space / background on logos should be made
                    transparent. This doesn’t include images with colored
                    backgrounds that are a set part of the logo.
                  </div>
                }
              />
            </div>
          </SimpleReactLightbox>
          <hr />
          <SimpleReactLightbox>
            <MultipleImageUploadComponent
              title="Add Photos*"
              smallTitle="(Add detail pictures of Business Establishment Images - If needed you can get a professional photo shoot to make it attractive this will appear on user app this will be reviewed periodically )"
              onChange={this.uploadMultipleFiles}
              stateValue={
                this.state.restaurant_pictures && this.state.restaurant_pictures
              }
              newUploaded={
                this.state.restaurant_pictures_new
                  ? this.state.restaurant_pictures_new
                  : []
              }
              combined={this.state.combined}
              onCompleteUploadMultipleCrop={this.onCompleteUploadMultipleCrop}
              removeImage={this.multipleResetFile}
              cancelFiles={this.cancelFiles}
              accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
              // loader={this.state.multipleImageLoader}
            />
            <div className="font_12_r c_gray mb-4 d-flex">
              <LearnMore
                preText={
                  <>
                    (You can add upto 6-10 pictures). Only .jpg and .png files.{" "}
                    2{/* {parseInt(imageUploadSize / 100000)} */}
                    MB max file size.
                  </>
                }
                mainContent={
                  <div className="f14-400">
                    Photos of Business Establishments/ Restaurants A complete
                    set of façade, ambiance, and food shots on a restaurant page
                    gives the diner all the information he needs to make a
                    decision. Some pointers to remember while uploading photos
                    for the restaurant are:   <br />
                    <br />· An order is followed in which photos appear on the
                    photo stream, which is maintained for all restaurants:
                    [Façade/exterior shots] — [Ambiance/interior shots] — [Food
                    shots]. <br />
                    <br />· Facade shots are photos taken from the exterior of
                    the restaurant, typically including the sign and the
                    entrance   <br />
                    <br />· Ambiance shots are photos of the interiors of the
                    restaurant that give the users information about the
                    lighting or seating arrangement at the restaurant   <br />
                    <br />· Food shots are images of food prepared by that
                    specific restaurant   <br />
                    <br />· The image should have high resolution (images with
                    1200×500 pixels or greater in resolution) <br />
                    <br />· We currently only support .JPEG and .PNZ file
                    formats for photo uploads. <br />
                    <br />· A single frame can only contain a single photo.
                    Avoid uploading photo collages as they don’t always show a
                    clear picture of what’s at the restaurant.   · Horizontal
                    photos are preferred, as they would be better suited to the
                    page layout. While vertical photos are allowed, the focal
                    elements of the image may be lost when it is cropped to the
                    required dimensions. <br />
                    <br />· Websites, phone numbers, and other text should not
                    be superimposed on the photo <br />
                    <br />· Do not put up images with people in them.   <br />
                    <br />· Do not put up ambiance/food shots that are stock
                    images, or taken from Google Images/other websites, as that
                    would amount to copyright infringement.  <br />
                    <br />· Do not put up photos which contains obscene, foul,
                    etc. characters which might be unpleasant to the diners{" "}
                    <br />
                    <br />· Even if stock photos have been legally purchased by
                    the restaurant, they are not uploaded as they do not depict
                    the true nature of the food and service provided by the
                    restaurant. This is misleading for diners.   <br />
                    <br />· Do not use images where logos and social media
                    handles take up a significant portion of the image. We’re a
                    neutral platform, and we don’t indulge in promoting any
                    particular restaurant.   <br />
                    <br />· No images from other sources. No images that
                    infringe on any copyright, trademark, or other legal
                    property rights. Amealio reserves the right, at any time and
                    without prior notice to delete any images and photos from
                    such Restaurant's / Business Establishment listing page that
                    it considers to be objectionable for any reason or no
                    reason, in violation of the Terms or otherwise harmful to
                    the services at its sole discretion.
                  </div>
                }
              />
            </div>
          </SimpleReactLightbox>
          <hr />
          <SimpleReactLightbox>
            <MultipleImageUploadComponent
              title="Add Video"
              smallTitle="( Add Videos or 360 view of Business Establishment - If needed you can get a professional photo shoot or video to make it attractive - this will appear on user app)"
              onChange={this.uploadMultipleVideoFiles}
              stateValue={video_url === "" ? [] : [video_url]}
              removeImage={this.multipleVideoResetFile}
              accept="video/*"
              singleUpload={true}
              videoUpload={true}
              // loader={this.state.multipleImageLoader}
            />
            <div className="font_12_r c_gray mb-4 d-flex">
              <LearnMore
                preText={<>(You can add upto 6 videos)</>}
                mainContent={
                  <div className="f14-400">
                    Video <br />A complete set of façade, ambiance, and food
                    video shots on a restaurant page gives the diner all the
                    information he needs to make a decision. As the restaurant,
                    it's your responsibility to ensure that your content and
                    conduct follow these rules- <br />
                    <br />· Videos that showcases the restaurant's
                    infrastructure, amenities, ambiance, furniture, cutlery,
                    food. This is because users want to know the factors that
                    could affect their experience. These videos are added help
                    to customers to identify the restaurant virtually.   <br />o
                    Facade Video are videos taken from the exterior of the
                    restaurant, typically including the sign and the entrance  
                    <br />
                    o Ambiance Video are videos of the interiors of the
                    restaurant that give the users information about the
                    lighting or seating arrangement at the restaurant   <br />o
                    Food Video are videos of food prepared by that specific
                    restaurant     <br />
                    <br />· We do not put up ambiance/food video that are stock
                    video, or taken from Google videos/other websites, as that
                    would be copyright infringement.   <br />
                    <br />· The video should have high resolution (with 1200x500
                    pixels or greater in resolution).   <br />
                    <br />· We do not put up videos which contains obscene,
                    foul, etc. characters which might be unpleasant to the
                    diners <br />
                    <br />· We do not upload videos that are made for spam and
                    deceptive practices <br />
                    <br />· We do not upload videos that contains Sensitive
                    content -includes child safety, nudity and sexual content,
                    etc. <br />
                    <br />· Videos need to appealing to users
                    <br />
                    <br />· Videos that are not blurry or unclear  <br />
                    <br />· Videos that are related or relevant to dine-in
                    experience  <br />
                    <br />· Videos should not contain watermarks Video
                    Guidelines <br />
                    <br />· Recommended video dimensions {VIDEO_MIN_WIDTH}{" "}
                    pixels for Landscape and Portrait. <br />
                    <br />· Minimum width is {VIDEO_MIN_WIDTH} pixels (length
                    depends on aspect ratio) for Landscape and Portrait. <br />
                    <br />· Landscape aspect ratio is 16:9. <br />· Portrait
                    aspect ratio is 9:16 (if video includes link, aspect ratio
                    is 9:16). <br />
                    <br />· Mobile renders both video types to aspect ratio
                    9:16. <br />
                    <br />· Max file size is{" "}
                    {parseInt(videoUploadSize / 1000000)}MB. <br />
                    <br />· Recommended video formats are mp4. <br />
                    <br />· Video length max is 3 minutes. <br />
                    <br />· Video max frames 30 fps Amealio reserves the right,
                    at any time and without prior notice to delete any videos
                    from such Restaurant's / Business Establishment listing page
                    that it considers to be objectionable for any reason or no
                    reason, in violation of the Terms or otherwise harmful to
                    the services at its sole discretion.
                  </div>
                }
              />
            </div>
          </SimpleReactLightbox>
          {!this.state.progress && this.state.progress === 0 ? null : (
            <AlertDialogProgress
              progress={this.state.progress}
              title="Video Uploading..."
            />
          )}

          <div className="col-12 p-0 mb-5 onboarding-restaurant-details-margin">
            <p className="f12-500 mb-3">Things To Do Nearby</p>
            <NewInputText
              extraClass="text-area-labelText-padding-two"
              name="things_nearby"
              onChange={this.onChange}
              onFocusOut={this.onFocusOut}
              rows="4"
              multiline={true}
              value={things_nearby}
              // labelText="Things To Do Nearby"
              helpTextDisplay={true}
              helperTextBottom="(Mention and suggest things to do nearby your restaurant. This will be shown on the user app and will acknowledge the users about your surroundings )"
              controlClass={"outlined-helperText "}
            />
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              onClick={this.backbuttonClickhandler}
              buttonType="button"
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonText="Next"
              buttonType="button"
              buttonClass={
                restaurant_description === "" ||
                logo_url.length === 0 ||
                restaurant_pictures.length === 0
                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                  : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              }
              disabled={
                restaurant_description === "" ||
                logo_url.length === 0 ||
                restaurant_pictures.length === 0
                  ? true
                  : false
              }
              onClick={
                actionButton === false ? this.withOutApiCall : this.handleSubmit
              }
            />
            {/* </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div className="col-6 pl-5 pr-5">
                <div className="super_admin_add_vendor mb-4">
                  <h5 className="main_header_text">
                    {this.props?.editDataAction ? "Edit" : "Add"} Vendor
                  </h5>
                  <h4 className="font_20_m">Step : 4</h4>
                  <h4 className="font_20_m c_red mt-2 mb-1">
                    Business Details
                  </h4>
                  <hr className="hr_line" />
                </div>
                <TopTextReusableComponent
                  headingText="Business Details"
                  headingParagraph="Please enter your Business Details - this will be shown to the user - please be diligent to fill the details."
                />
                <Form noValidate onSubmit={this.handleSubmit}>
                  {this.renderAllFields()}
                </Form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SuperAdminAddRestaurantDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboardingData: state.superAdminOnboarding.restaurantDetails,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_create_and_update_restaurant,
})(withRouter(SuperAdminAddRestaurantDetails));

export const LearnMore = (props) => {
  const [showLearn, showLearnMore] = useState(false);
  const handleComplete = () => showLearnMore(false);
  return (
    <React.Fragment>
      <div className={props.buttonClass}>
        {props?.preText}
        <span
          style={{
            color: props.learnMoreDefault ? "#2196F3" : "#EE3A23",
            cursor: "pointer",
          }}
          onClick={() => showLearnMore(true)}
        >
          {props.buttonDisplay ? props.buttonText : "Learn more"}
        </span>
        <div>
          <Dialog
            open={showLearn}
            onClose={handleComplete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title"></DialogTitle>
            <DialogContent>
              {props.mainContent}
              <div align="center">
                <button
                  style={{ width: "250px" }}
                  onClick={handleComplete}
                  className="btn btn-danger"
                >
                  Okay
                </button>
              </div>
              {/* <DialogContentText id="alert-dialog-description"></DialogContentText> */}
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </React.Fragment>
  );
};
